import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from "react";

/** Optionele knop in de melding, zoals "Ongedaan maken". */
export interface ToastAction {
  label: string;
  onClick: () => void;
}
type Show = (msg: string, opts?: { action?: ToastAction; ms?: number }) => void;

const ToastContext = createContext<Show>(() => {});

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<{ msg: string; action?: ToastAction } | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  const show = useCallback<Show>((msg, opts) => {
    setToast({ msg, action: opts?.action });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), opts?.ms ?? (opts?.action ? 10_000 : 3500));
  }, []);
  return (
    <ToastContext.Provider value={show}>
      {children}
      <div role="status" aria-live="polite">
        {toast && (
          <div className={`toast ${toast.action ? "toast-action" : ""}`}>
            <span>{toast.msg}</span>
            {toast.action && (
              <button
                type="button"
                className="btn small"
                onClick={() => {
                  clearTimeout(timer.current);
                  setToast(null);
                  toast.action!.onClick();
                }}
              >
                {toast.action.label}
              </button>
            )}
          </div>
        )}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
